// src/components/PecTutor/composables/useFeedback.ts
import { useMainStore } from "@/store/main";
const PREDICTION_API_URL = process.env.VUE_APP_PREDICTION_API_URL || 'https://prediction-api.pecsmart.cloud';

interface UserNotePayload {
  user_id: number;
  username: string;
  note_value: string;
  note_identification: string; // e.g., current route
  additional_info?: Record<string, unknown>;
}

export function useFeedback() {
  const mainStore = useMainStore();

  const sendFeedback = async (note: string) => {
    const payload: UserNotePayload = {
      user_id: mainStore.user?.id ?? 0,
      username: mainStore.user?.username ?? 'anonymous',
      note_value: note,
      note_identification: window.location.pathname,
      additional_info: {
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      },
    };

    try {
      await mainStore.postOnAPI(`${PREDICTION_API_URL}/user-notes/`, payload);
    } catch (error) {
      // Handle error
      console.error('Error submitting feedback:', error);
    }
  };

  return { sendFeedback };
}
